import { Capacitor } from '@capacitor/core';

/** Dónde corre la web: dentro de la app de iPhone, de la de Android, o en un navegador. */
export type Plataforma = 'ios' | 'android' | 'web';

/**
 * ¿Estamos dentro de la app nativa? Es la ÚNICA forma de distinguir la app de la web: la web va
 * metida en el binario y es la misma. En cualquier navegador (también Safari en un iPhone) es
 * `false`. Todo lo de `src/movil/` que solo debe pasar en la app pregunta aquí.
 */
export const esApp = (): boolean => Capacitor.isNativePlatform();

/** ¿Es la app de iPhone? (Face ID, el zoom al escribir… solo pasan ahí). */
export const esIphone = (): boolean => Capacitor.getPlatform() === 'ios';

/** El nombre de la plataforma, para mandárselo a la API (`X-Client-Platform`). */
export const plataforma = (): Plataforma => Capacitor.getPlatform() as Plataforma;
